import { P2GGrid } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import AlertWithIcon from '../../AlertWithIcon';
import { ServiceRestrictionType } from './utils/GetServiceRestrictions';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  errors: ServiceRestrictionType[];
}

function Message(props: { error: ServiceRestrictionType }) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  switch (props.error) {
    case 'COLLECTION':
      return (
        <P2GText variant="body2">
          {t('COLLECTION_ERROR_MESSAGE', { defaultValue: 'This service does not collect from your selected country.' })}
        </P2GText>
      );
    case 'DELIVERY':
      return (
        <P2GText variant="body2">
          {t('DELIVERY_ERROR_MESSAGE', { defaultValue: 'This service does not deliver to your selected country.' })}
        </P2GText>
      );
    case 'WEIGHT':
      return (
        <P2GText variant="body2">
          {t('WEIGHT_ERROR_MESSAGE', { defaultValue: 'Your parcel is too heavy for this service.' })}
        </P2GText>
      );
    case 'DIMENSIONS':
      return (
        <P2GText variant="body2">
          {t('DIMENSIONS_ERROR_MESSAGE', { defaultValue: 'Your parcel is too big for this service.' })}
        </P2GText>
      );
    default:
      return <P2GText variant="body2">{props.error}</P2GText>;
  }
}

export function ServiceRestrictions(props: props) {
  if (!props.errors || props.errors.length == 0) {
    return null;
  }
  return (
    <AlertWithIcon iconSize="sm" color="error">
      <P2GGrid container direction="column" spacing={1}>
        {props.errors.map((m) => (
          <P2GGrid item key={m}>
            <Message error={m} />
          </P2GGrid>
        ))}
      </P2GGrid>
    </AlertWithIcon>
  );
}
